import { render, staticRenderFns } from "./customerServiceList.vue?vue&type=template&id=e1166d84&scoped=true&"
import script from "./customerServiceList.vue?vue&type=script&lang=js&"
export * from "./customerServiceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1166d84",
  null
  
)

export default component.exports